/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import React, { useState } from "react";
import { useRouter } from "next/navigation";
import { Accordion, AccordionItem } from "@heroui/accordion";
import { Button } from "@heroui/button";
import Image from "next/image";

interface ServiceCTAAccordionProps {
  heading: string;
  servicesList: any[];
  type?: "type-left" | "type-right";
}

const ServicesCTAAccordion: React.FC<ServiceCTAAccordionProps> = ({
  heading,
  servicesList,
  type = "type-left",
}) => {
  const router = useRouter();
  const [activeIndex, setActiveIndex] = useState<string>("0");

  return (
    <section className={`w-full ${type === "type-left" ? "bg-[#F3F7FF]" : ""}`}>
      <div className="flex flex-col md:flex-row items-center justify-start px-4 md:px-14 xl:px-[100px] max-w-[1440px] mx-auto py-10 gap-5 md:gap-10">
        <div
          className={`flex flex-col gap-10 md:gap-[60px] w-full ${type === "type-left" ? "" : "md:order-2"}`}
        >
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-medium md:text-left text-center w-full">
            {heading}
          </h2>
          <Accordion
            selectedKeys={[activeIndex]}
            onSelectionChange={(keys: any) =>
              setActiveIndex(keys.currentKey || "")
            }
          >
            {servicesList.map((service: any, index: number) => (
              <AccordionItem
                key={index}
                classNames={{
                  title: "text-xl md:text-2xl data-[open=true]:font-medium",
                }}
                title={service.value.title}
              >
                <div className="flex flex-col gap-4 md:gap-6 mb-5">
                  <p>{service.value.description}</p>
                  <Image
                    alt={service.value.image.title}
                    className="w-full h-auto aspect-square object-cover max-w-[500px] md:hidden"
                    height={400}
                    src={service.value.image.download_url}
                    width={400}
                  />
                  <Button
                    className="bg-ax-primary font-medium w-fit"
                    radius="lg"
                    onPress={() => router.push(service.value.button_link)}
                  >
                    Shop Now
                  </Button>
                </div>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <Image
          alt={servicesList[Number(activeIndex)].value.image.title}
          className="hidden md:block w-full h-auto aspect-square object-cover max-w-[500px]"
          height={400}
          src={servicesList[Number(activeIndex)].value.image.download_url}
          width={400}
        />
      </div>
    </section>
  );
};

export default ServicesCTAAccordion;
